function getDeliveryText(isFreeShipping) {
  const today = new Date();
  let startDate = new Date(today);
  startDate.setDate(today.getDate() + 1);
  if (startDate.getDay() === 0) {
    startDate.setDate(startDate.getDate() + 1);
  }
  let endDate = new Date(startDate);
  let addedDays = 0;
  while (addedDays < 2) {
    endDate.setDate(endDate.getDate() + 1);
    if (endDate.getDay() !== 0) {
      addedDays++;
    }
  }
  const weekdayNames = ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."];
  function formatDate(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const weekday = weekdayNames[date.getDay()];
    return `${weekday} ${day}.${month}.`;
  }

  return {
    left: `Lieferung ca. ${formatDate(startDate)} - ${formatDate(endDate)}`,
    // left: `Versand:`,
    right: isFreeShipping,
  };
}
window.addEventListener("OpusCartChange", (e) => {
  document.querySelectorAll(".money").forEach((el) => {
    if (el.querySelector(".opus-original-price")) {
      const finalPrice = el.querySelector(".opus-final-price");
      if (finalPrice) {
        finalPrice.style.color = "red";
      }
    }
  });
  const btn = document.getElementById("opus-checkout-btn-2");
  if (btn) {
    const existing = document.querySelector(".delivery-text");
    if (existing) existing.remove();
  const country = Shopify.country;
let isFreeShipping = 'Kostenlos';
if (country === 'AT') {
    isFreeShipping = e.detail.total_price / 100 >= 49 ? 'Kostenlos' : '';
}
if (country === 'CH') {
    isFreeShipping = e.detail.total_price / 100 >= 150 ? 'Kostenlos' : '';
}
if (country === 'DE') {
    isFreeShipping = e.detail.total_price / 100 >= 39 ? 'Kostenlos' : '';
}
    const deliveryData = getDeliveryText(isFreeShipping);
    const deliveryEl = document.createElement("div");
    deliveryEl.className = "delivery-text";
    deliveryEl.style.color = "green";
    deliveryEl.style.color = "green";
    deliveryEl.style.marginBottom = "10px";
    deliveryEl.style.display = "flex";
    deliveryEl.style.justifyContent = "space-between";
    deliveryEl.style.fontWeight = "500";
    const leftSpan = document.createElement("span");
    leftSpan.textContent = deliveryData.left;
    const rightSpan = document.createElement("span");
    rightSpan.textContent = deliveryData.right;
     if (isFreeShipping !== 'Kostenlos') {
      rightSpan.style.color = "black";
    } else {
      rightSpan.style.color = "green";
    }
    deliveryEl.appendChild(leftSpan);
    deliveryEl.appendChild(rightSpan);
    btn.parentNode.insertBefore(deliveryEl, btn);
  }


  if (!document.querySelector('.opus-extra-noti-discount')) {
    document.querySelector('.cd-checkout-section-container').insertAdjacentHTML("afterbegin",
        `
        <div class="opus-extra-noti-discount" style="display:none;">
            Rabatt aktiviert - Zwischensumme aktualisiert
        </div>
        `
    );
  }

  const discount = event.detail.discount_codes;
  if (discount.length > 0) {
      document.querySelector('.opus-extra-noti-discount').style.display = "block";
  } else {
      document.querySelector('.opus-extra-noti-discount').style.display = "none";
  }

  
  const discount_amount = ((window?.opusCartPriceInfo?.totalCompareAtPrice ?? 0) +(window?.opusCartPriceInfo?.totalDiscountCode ?? 0) );
  
  let countSetInter = 0;
  const timerDiscount = setInterval(() => {
    const discount_el = document.querySelector('.cd-checkout-section-discount-amount .money');
    countSetInter++;
    if (discount_el) {
      discount_el.innerHTML = window.OpusConvertMoney(discount_amount);
    }
    if (discount_el || countSetInter === 20) {
      clearInterval(timerDiscount);
    }
  }, 100);
  
});

function handleCartEvents(event) {
  const checkoutPrice = event.detail.total_price || event.detail.cart.total_price;
  const subtotalEl = document.querySelector('.opus-subtotal-amount.money');

  if (subtotalEl) {
    const existingSave = subtotalEl.parentNode.querySelector('.opus-original-save');
    if (existingSave) existingSave.remove();

    const totalCompareAtPrice = window?.opusCartPriceInfo?.totalCompareAtPrice ?? 0;
    const totalDiscount = window?.opusCartPriceInfo?.totalDiscount ?? 0;

    const discount = totalCompareAtPrice + totalDiscount;
    const originalTotal = checkoutPrice + discount;

    const saveAmount = document.createElement('span');
    saveAmount.className = 'opus-original-save money';
    saveAmount.textContent = window.OpusConvertMoney
      ? window.OpusConvertMoney(originalTotal)
      : `$${(originalTotal / 100).toFixed(2)}`;
    saveAmount.style.textDecoration = 'line-through';
    saveAmount.style.marginLeft = '8px';
    saveAmount.style.color = '#888';

  const productList = document.querySelector('.opus-drawer-container-header');
  if (productList && !document.querySelector('.custom-upsell-banner')) {
    const img = document.createElement('img');
    // Opus start
    img.src = 'https://cdn.shopify.com/s/files/1/0669/3326/0556/files/Bildschirmfoto_2026-05-31_um_17.38.06.png?v=1780241923';
    // Opus end
    img.alt = 'Upsell Banner';
    img.className = 'custom-upsell-banner';
    img.style.width = '100%';

    productList.parentNode.insertBefore(img, productList.nextSibling);

  }
}


}


window.addEventListener('OpusCartChange', handleCartEvents);
window.addEventListener('OpusOpenCartState', handleCartEvents);

window.opusDiscountPriceWithCompareAtPrice = true;



 (function (ns, originalFetch) {
    ns.fetch = function (...args) {
      const fetchPromise = originalFetch.apply(this, args);

      fetchPromise.then(async (res) => {
        try {
          // Xác định URL gọi (ưu tiên args để bắt đúng /cart.js)
          const url = typeof args[0] === 'string'
            ? args[0]
            : (args[0] && args[0].url) || res.url;

          if (res.ok && /\/cart\.js(\?|$)/.test(url)) {
            const data = await res.clone().json(); // đọc từ bản sao
            console.log('[cart.js data]', data);

            window.OpusSetCartData(data)

          }
        } catch (e) {
          console.error('Intercept cart.js error:', e);
        }
      });

      return fetchPromise;
    };
  })(window, window.fetch);


// function handleCartEvents(event) {
//   const checkoutPrice =
//     event.detail.total_price || event.detail.cart.total_price;
//   const subtotalEl = document.querySelector(".opus-subtotal-amount.money");
//   if (subtotalEl) {
//     const existingSave = subtotalEl.parentNode.querySelector(
//       ".opus-original-save"
//     );
//     if (existingSave) existingSave.remove();
//     const totalCompareAtPrice =
//       window?.opusCartPriceInfo?.totalCompareAtPrice ?? 0;
//     const totalDiscount = window?.opusCartPriceInfo?.totalDiscount ?? 0;
//     const discount = totalCompareAtPrice + totalDiscount;
//     const originalTotal = checkoutPrice + discount;
//     const saveAmount = document.createElement("span");
//     saveAmount.className = "opus-original-save money";
//     saveAmount.textContent = window.OpusConvertMoney
//       ? window.OpusConvertMoney(originalTotal)
//       : `$${(originalTotal / 100).toFixed(2)}`;
//     saveAmount.style.textDecoration = "line-through";
//     saveAmount.style.marginLeft = "8px";
//     saveAmount.style.color = "#888";
//     if (discount > 0) {
//       subtotalEl.insertAdjacentElement("beforeend", saveAmount);
//     }
//   }
//   // const buttons = document.querySelectorAll(
//   //   ".opus-button-warp-upsell > .cd-buy-button.cd-main-button"
//   // );
//   // buttons.forEach((button) => {
//   //   button.innerHTML = "Hinzufügen";
//   // });
//   const productList = document.querySelector(".opus-drawer-container-header");
//   if (productList && !document.querySelector(".custom-upsell-banner")) {
//     const img = document.createElement("img");
//     img.src =
//       "https://cdn.shopify.com/s/files/1/0669/3326/0556/files/Stark_gewaehlt.-2.jpg?v=1752242698";
//     img.alt = "Upsell Banner";
//     img.className = "custom-upsell-banner";
//     img.style.width = "100%";
//     productList.parentNode.insertBefore(img, productList.nextSibling);
//   }
// }

// window.addEventListener("OpusCartChange", handleCartEvents);
// window.addEventListener("OpusOpenCartState", handleCartEvents);
// window.opusDiscountPriceWithCompareAtPrice = true;
// window.addEventListener ('OpusCartChange', (event) => {

//     if (!document.querySelector('.opus-extra-text')) {
    
//     document.querySelector('#opus-checkout-btn-2').insertAdjacentHTML("afterend",
//               `<div class="opus-extra-text">Bruchsichere Qualität | Bewährt im Training</div>`) ;
//     }})
